import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultGlobalAdminNavigation: FuseNavigationItem[] = [
    {
        id: 'account',
        title: 'Navigation.Account',
        type: 'collapsable',
        icon: 'heroicons_outline:user',
        children: [
            {
                id: 'account.users',
                title: 'Navigation.Users',
                type: 'basic',
                link: '/account/users',
            },
            {
                id: 'account.mandats',
                title: 'Navigation.Mandats',
                type: 'basic',
                link: '/account/mandats',
            },
            {
                id: 'account.tenants',
                title: 'Navigation.Tenants',
                type: 'basic',
                link: '/account/tenants',
            },
            // Deferred: keep this page for a later decision on whether it is needed.
            /* {
                id: 'account.system-admins',
                title: 'Navigation.SystemAdmins',
                type: 'basic',
                link: '/account/system-admins',
            }, */
            {
                id: 'account.registration-users',
                title: 'Navigation.Registration',
                type: 'collapsable',
                children: [
                    {
                        id: 'account.registration-users.users',
                        title: 'Navigation.RegisteredUsers',
                        type: 'basic',
                        link: '/account/registration-users/registrations',
                    },
                    {
                        id: 'account.registration-users.declined',
                        title: 'Navigation.DeclinedRegistrations',
                        type: 'basic',
                        link: '/account/registration-users/declined',
                    },
                ],
            },
        ],
    },
    {
        id: 'roles',
        title: 'Navigation.RolesAndPackages',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/general-data/roles',
    },
    {
        id: 'admin.vin-request-history',
        title: 'Navigation.VINRequestHistory',
        type: 'basic',
        icon: 'heroicons_outline:clock',
        link: '/admin/vin-request-history',
    },
    {
        id: 'warranties',
        title: 'Navigation.Warranties',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document-check',
        children: [
            {
                id: 'nsa',
                title: 'Navigation.NSA',
                type: 'basic',
                link: '/warranties',
            },
        ],
    },
    {
        id: 'scheduled-jobs',
        title: 'Navigation.ScheduledJobs',
        icon: 'heroicons_outline:briefcase',
        type: 'basic',
        link: '/scheduled-jobs',
    },
    {
        id: 'energy-labels',
        title: 'Navigation.EnergyLabels',
        icon: 'heroicons_outline:bolt',
        type: 'basic',
        link: '/energy-labels',
    },
    {
        id: 'general-data',
        title: 'Navigation.GeneralData',
        type: 'collapsable',
        icon: 'heroicons_outline:map',
        children: [
            {
                id: 'canton',
                title: 'Navigation.Canton',
                type: 'basic',
                link: '/general-data/cantons',
            },
            {
                id: 'country',
                title: 'Navigation.Country',
                type: 'basic',
                link: '/general-data/countries',
            },
            {
                id: 'bank',
                title: 'Navigation.Bank',
                type: 'basic',
                link: '/general-data/banks',
            },
            {
                id: 'general-data.vehicle-types',
                title: 'GeneralDataReference.Tables.VehicleType',
                type: 'basic',
                link: '/general-data/vehicle-types',
            },
            {
                id: 'general-data.makes',
                title: 'GeneralDataReference.Tables.Make',
                type: 'basic',
                link: '/general-data/makes',
            },
            {
                id: 'general-data.models',
                title: 'GeneralDataReference.Tables.Model',
                type: 'basic',
                link: '/general-data/models',
            },
            {
                id: 'general-data.bodies',
                title: 'GeneralDataReference.Tables.Body',
                type: 'basic',
                link: '/general-data/bodies',
            },
            {
                id: 'general-data.conditions',
                title: 'GeneralDataReference.Tables.Condition',
                type: 'basic',
                link: '/general-data/conditions',
            },
            {
                id: 'general-data.ratings',
                title: 'GeneralDataReference.Tables.Rating',
                type: 'basic',
                link: '/general-data/ratings',
            },
            {
                id: 'general-data.segmentations',
                title: 'GeneralDataReference.Tables.Segmentation',
                type: 'basic',
                link: '/general-data/segmentations',
            },
            {
                id: 'general-data.drives',
                title: 'GeneralDataReference.Tables.Drive',
                type: 'basic',
                link: '/general-data/drives',
            },
            {
                id: 'general-data.fuels',
                title: 'GeneralDataReference.Tables.Fuel',
                type: 'basic',
                link: '/general-data/fuels',
            },
            {
                id: 'general-data.interiors',
                title: 'GeneralDataReference.Tables.Interior',
                type: 'basic',
                link: '/general-data/interiors',
            },
            {
                id: 'general-data.pollution-norms',
                title: 'GeneralDataReference.Tables.PollutionNorm',
                type: 'basic',
                link: '/general-data/pollution-norms',
            },
            {
                id: 'general-data.transmissions',
                title: 'GeneralDataReference.Tables.Transmission',
                type: 'basic',
                link: '/general-data/transmissions',
            },
            {
                id: 'general-data.equipment',
                title: 'GeneralDataReference.Tables.Equipment',
                type: 'basic',
                link: '/general-data/equipment',
            },
            {
                id: 'general-data.properties',
                title: 'GeneralDataReference.Tables.Property',
                type: 'basic',
                link: '/general-data/properties',
            },
            {
                id: 'general-data.extras',
                title: 'GeneralDataReference.Tables.Extra',
                type: 'basic',
                link: '/general-data/extras',
            },
            {
                id: 'general-data.statuses',
                title: 'GeneralDataReference.Tables.Status',
                type: 'basic',
                link: '/general-data/statuses',
            },
            {
                id: 'general-data.warranty-types',
                title: 'GeneralDataReference.Tables.WarrantyType',
                type: 'basic',
                link: '/general-data/warranty-types',
            },
            {
                id: 'general-data.body-colors',
                title: 'GeneralDataReference.Tables.BodyColor',
                type: 'basic',
                link: '/general-data/body-colors',
            },
            {
                id: 'general-data.cylinder-design-types',
                title: 'GeneralDataReference.Tables.CylinderDesignType',
                type: 'basic',
                link: '/general-data/cylinder-design-types',
            },
            {
                id: 'general-data.dealer-rating-reporting-reasons',
                title: 'GeneralDataReference.Tables.DealerRatingReportingReason',
                type: 'basic',
                link: '/general-data/dealer-rating-reporting-reasons',
            },
            {
                id: 'general-data.document-types',
                title: 'GeneralDataReference.Tables.DocumentType',
                type: 'basic',
                link: '/general-data/document-types',
            },
            {
                id: 'general-data.license-category-types',
                title: 'GeneralDataReference.Tables.LicenseCategoryType',
                type: 'basic',
                link: '/general-data/license-category-types',
            },
            {
                id: 'general-data.phone-types',
                title: 'GeneralDataReference.Tables.PhoneType',
                type: 'basic',
                link: '/general-data/phone-types',
            },
            {
                id: 'general-data.purchase-time-types',
                title: 'GeneralDataReference.Tables.PurchaseTimeType',
                type: 'basic',
                link: '/general-data/purchase-time-types',
            },
            {
                id: 'general-data.status-types',
                title: 'GeneralDataReference.Tables.StatusType',
                type: 'basic',
                link: '/general-data/status-types',
            },
            {
                id: 'general-data.transmission-shaft-types',
                title: 'GeneralDataReference.Tables.TransmissionShaftType',
                type: 'basic',
                link: '/general-data/transmission-shaft-types',
            },
            {
                id: 'general-data.vehicle-type-groups',
                title: 'GeneralDataReference.Tables.VehicleTypeGroup',
                type: 'basic',
                link: '/general-data/vehicle-type-groups',
            },
        ],
    },
    {
        id: 'contract',
        title: 'Navigation.Contract',
        type: 'collapsable',
        hidden: () => true,
        icon: 'heroicons_outline:document-check',
        children: [
            {
                id: 'warranty-coverage',
                title: 'Navigation.WarrantyCoverage',
                type: 'basic',
                link: '/general-data/warranty-coverage',
            },
            {
                id: 'warranty-option',
                title: 'Navigation.WarrantyOption',
                type: 'basic',
                link: '/general-data/warranty-option',
            },
        ],
    },
    {
        id: 'traffic-department',
        title: 'Navigation.TrafficDepartment',
        type: 'collapsable',
        hidden: () => true,
        icon: 'heroicons_outline:truck',
        children: [
            {
                id: 'certification',
                title: 'Navigation.Certification',
                type: 'basic',
                link: '/traffic-department/certification',
            },
            {
                id: 'class',
                title: 'Navigation.Class',
                type: 'basic',
                link: '/traffic-department/class',
            },
            {
                id: 'color',
                title: 'Navigation.Color',
                type: 'basic',
                link: '/traffic-department/color',
            },
            {
                id: 'consumption',
                title: 'Navigation.Consumption',
                type: 'basic',
                link: '/traffic-department/consumption',
            },
            {
                id: 'drive',
                title: 'Navigation.Drive',
                type: 'basic',
                link: '/traffic-department/drive',
            },
            {
                id: 'emission',
                title: 'Navigation.Emission',
                type: 'basic',
                link: '/traffic-department/emission',
            },
            {
                id: 'emission',
                title: 'Navigation.Emission',
                type: 'basic',
                link: '/traffic-department/emission',
            },
            {
                id: 'exhaust',
                title: 'Navigation.Exhaust',
                type: 'basic',
                link: '/traffic-department/exhaust',
            },
            {
                id: 'fuel',
                title: 'Navigation.Fuel',
                type: 'basic',
                link: '/traffic-department/fuel',
            },
            {
                id: 'gear',
                title: 'Navigation.Gear',
                type: 'basic',
                link: '/traffic-department/gear',
            },
            {
                id: 'inspection',
                title: 'Navigation.Inspection',
                type: 'basic',
                link: '/traffic-department/inspection',
            },
            {
                id: 'matriculation',
                title: 'Navigation.Matriculation',
                type: 'basic',
                link: '/traffic-department/matriculation',
            },
            {
                id: 'platform',
                title: 'Navigation.Platform',
                type: 'basic',
                link: '/traffic-department/platform',
            },
            {
                id: 'type',
                title: 'Navigation.Type',
                type: 'basic',
                link: '/traffic-department/type',
            },
        ],
    },
    {
        id: 'customs-department',
        title: 'Navigation.CustomsDepartment',
        type: 'collapsable',
        icon: 'heroicons_outline:computer-desktop',
        children: [
            {
                id: 'co2cost',
                title: 'Navigation.Co2Cost',
                type: 'basic',
                link: '/customs-department/co2-cost',
            },
            {
                id: 'median-deadweight',
                title: 'Navigation.MedianDeadweight',
                type: 'basic',
                link: '/customs-department/median-deadweight',
            },
            {
                id: 'median-deadweight-configs',
                title: 'Navigation.CustomsConfigs',
                type: 'basic',
                link: '/customs-department/config',
            },
        ],
    },
    {
        id: 'vehicle-data',
        title: 'Navigation.VehicleData',
        type: 'collapsable',
        icon: 'heroicons_outline:truck',
        children: [
            {
                id: 'vehicle-color',
                title: 'Navigation.VehicleColor',
                type: 'basic',
                link: '/vehicle-data/color',
            },
            {
                id: 'vehicle-group-part',
                title: 'Navigation.VehicleGroupPart',
                type: 'basic',
                link: '/vehicle-data/group-part',
            },
            {
                id: 'vehicle-parts',
                title: 'Navigation.VehicleParts',
                type: 'basic',
                link: '/vehicle-data/parts',
            },
        ],
    },
    {
        id: 'contract',
        title: 'Navigation.Contract',
        type: 'collapsable',
        hidden: () => true,
        icon: 'heroicons_outline:document-magnifying-glass',
        children: [
            {
                id: 'insurance-coverage',
                title: 'Navigation.InsuranceCoverage',
                type: 'basic',
                link: '/contract/insurance-coverage',
            },
            {
                id: 'warranty-coverage',
                title: 'Navigation.WarrantyCoverage',
                type: 'basic',
                link: '/contract/warranty-coverage',
            },
            {
                id: 'warranty-option',
                title: 'Navigation.WarrantyOption',
                type: 'basic',
                link: '/contract/warranty-option',
            },
            {
                id: 'contract-status',
                title: 'Navigation.ContractStatus',
                type: 'basic',
                link: '/contract/contract-status',
            },
        ],
    },
    {
        id: 'database',
        title: 'Navigation.Database',
        type: 'collapsable',
        hidden: () => true,
        icon: 'heroicons_outline:circle-stack',
        children: [
            {
                id: '24-auto-scout',
                title: 'Navigation.24AutoScout',
                type: 'basic',
                link: '/database/24-auto-scout',
            },
            {
                id: 'import-cars',
                title: 'Navigation.ImportCars',
                type: 'basic',
                link: '/database/import-cars',
            },
            {
                id: 'warranty-option',
                title: 'Navigation.WarrantyOption',
                type: 'basic',
                link: '/contract/warranty-option',
            },
            {
                id: 'Auto-I',
                title: 'Navigation.AutoI',
                type: 'basic',
                link: '/database/Auto-I',
            },
        ],
    },
    {
        id: 'support',
        title: 'Navigation.Support',
        type: 'collapsable',
        icon: 'heroicons_outline:question-mark-circle',
        children: [
            {
                id: 'support.operator-tickets',
                title: 'Navigation.Tickets',
                type: 'basic',
                link: '/operator/tickets',
            },
            {
                id: 'support.guidelines',
                title: 'Navigation.HelpCenter',
                type: 'basic',
                link: '/guidelines',
            },
        ],
    },
];
export const defaultMandatNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Navigation.Dashboard',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        children: [
            {
                id: 'dashboard.salesadmin',
                title: 'Navigation.SalesAdmin',
                type: 'basic',
                link: '/dashboard/sales-admin',
            },
            {
                id: 'dashboard.sales',
                title: 'Navigation.Sales',
                type: 'basic',
                link: '/dashboard/sales',
            },
            {
                id: 'dashboard.mandatadmin',
                title: 'Navigation.MandatAdmin',
                type: 'basic',
                link: '/dashboard/mandat-admin',
            },
            {
                id: 'dashboard.accounting',
                title: 'Navigation.Accounting',
                type: 'basic',
                link: '/dashboard/accounting',
            },
            {
                id: 'dashboard.purchase',
                title: 'Navigation.Purchase',
                type: 'basic',
                link: '/dashboard/purchase',
            },
        ],
    },
    {
        id: 'statistics',
        title: 'Navigation.Statistics',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-bar',
        children: [
            {
                id: 'statistics.contracts',
                title: 'Navigation.Contracts',
                type: 'basic',
                link: '/statistics/contracts',
            },
            {
                id: 'statistics.cars',
                title: 'Navigation.Cars',
                type: 'basic',
                link: '/statistics/cars',
            },
            {
                id: 'statistics.carReports',
                title: 'Navigation.CarReports',
                type: 'basic',
                link: '/statistics/car-reports',
            },
            {
                id: 'statistics.purchase',
                title: 'Navigation.Purchase',
                type: 'basic',
                link: '/statistics/purchase',
            },
        ],
    },
    {
        id: 'calendars',
        title: 'Navigation.Calendars',
        type: 'collapsable',
        icon: 'heroicons_outline:calendar-days',
        children: [
            {
                id: 'calendars.delivery-calendar',
                title: 'Navigation.DeliveryCalendar',
                type: 'basic',
                link: '/calendars/delivery-calendar',
            },
            {
                id: 'calendars.service/mkf-calendar',
                title: 'Navigation.Contracts',
                type: 'basic',
                link: '/calendars/mkf-calendar',
            },
            {
                id: 'calendars.test-drive-calendar',
                title: 'Navigation.TestDriveCalendar',
                type: 'basic',
                link: '/statistics/test-drive-calendar',
            },
        ],
    },
    {
        id: 'vehicles',
        title: 'Navigation.AllVehicles',
        type: 'basic',
        link: '/vehicles',
        icon: 'heroicons_outline:list-bullet',
    },
    {
        id: 'sales',
        title: 'Navigation.Sales',
        type: 'collapsable',
        icon: 'heroicons_outline:banknotes',
        children: [
            {
                id: 'sales.contracts',
                title: 'Navigation.Contracts',
                type: 'basic',
                link: '/sales/contracts',
            },
            {
                id: 'sales.delivery-notes',
                title: 'Navigation.DeliveryNotes',
                type: 'basic',
                link: '/sales/delivery-notes',
            },
            {
                id: 'sales.warranties',
                title: 'Navigation.Warranties',
                type: 'basic',
                link: '/sales/warranties',
            },
            {
                id: 'sales.funding',
                title: 'Navigation.Funding',
                type: 'basic',
                link: '/sales/funding',
            },
            {
                id: 'sales.funding-offers',
                title: 'Navigation.FundingOffers',
                type: 'basic',
                link: '/sales/funding-offers',
            },
            {
                id: 'sales.test-drive',
                title: 'Navigation.TestDrive',
                type: 'basic',
                link: '/sales/test-drive',
            },
            {
                id: 'sales.trade-in-vehicle',
                title: 'Navigation.TradeInVehicle',
                type: 'basic',
                link: '/sales/trade-in-vehicle',
            },
        ],
    },
    {
        id: 'administration',
        title: 'Navigation.Administration',
        type: 'collapsable',
        icon: 'heroicons_outline:building-library',
        children: [
            {
                id: 'administration.purchase',
                title: 'Navigation.Purchase',
                type: 'basic',
                link: '/administration/purchase',
            },
            {
                id: 'administration.co2',
                title: 'Navigation.CO2',
                type: 'basic',
                link: '/administration/co2',
            },
            {
                id: 'administration.custom-invoice',
                title: 'Navigation.CustomInvoice',
                type: 'basic',
                link: '/administration/custom-invoice',
            },
            {
                id: 'administration.vin-request-history',
                title: 'Navigation.VINRequestHistory',
                type: 'basic',
                link: '/administration/vin-request-history',
            },
        ],
    },
    {
        id: 'accounting',
        title: 'Navigation.Accounting',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document-check',
        children: [
            {
                id: 'accounting.cash-book',
                title: 'Navigation.CashBook',
                type: 'basic',
                link: '/accounting/cash-book',
            },
            {
                id: 'accounting.payroll',
                title: 'Navigation.Payroll',
                type: 'basic',
                link: '/book-keeping/payroll',
            },
            {
                id: 'accounting.incoming',
                title: 'Navigation.Incoming',
                type: 'basic',
                link: '/book-keeping/incoming',
            },
            {
                id: 'accounting.outgoing',
                title: 'Navigation.Outgoing',
                type: 'basic',
                link: '/book-keeping/outgoing',
            },
        ],
    },
    {
        id: 'clients',
        title: 'Navigation.Clients',
        type: 'basic',
        link: '/clients',
        icon: 'heroicons_outline:user-group',
        children: [],
    },
    {
        id: 'partners',
        title: 'Navigation.Partners',
        type: 'collapsable',
        icon: 'heroicons_outline:shopping-cart',
        children: [
            {
                id: 'partners.other-partners',
                title: 'Navigation.OtherPartners',
                type: 'basic',
                link: '/partners/other-partners',
            },
            {
                id: 'partners.insurance-partners',
                title: 'Navigation.InsurancePartners',
                type: 'basic',
                link: '/partners/insurance-partners',
            },
            {
                id: 'partners.warranty-partners',
                title: 'Navigation.WarrantyPartners',
                type: 'basic',
                link: '/partners/warranty-partners',
            },
            {
                id: 'partners.funding-providers',
                title: 'Navigation.FundingProviders',
                type: 'basic',
                link: '/partners/funding-providers',
            },
        ],
    },
    {
        id: 'settings',
        title: 'Navigation.Settings',
        type: 'basic',
        icon: 'heroicons_outline:cog-8-tooth',
        link: '/settings',
    },
    {
        id: 'time-tracking',
        title: 'timeTracking.title',
        type: 'basic',
        link: '/time-tracking',
        icon: 'heroicons_outline:clock',
    },
    {
        id: 'messages',
        title: 'Navigation.Messages',
        type: 'basic',
        icon: 'heroicons_outline:envelope',
        children: [],
    },
    {
        id: 'show-rooms',
        title: 'Navigation.ShowRooms',
        type: 'basic',
        icon: 'heroicons_outline:envelope',
        children: [],
    },
    {
        id: 'website',
        title: 'Navigation.Website',
        type: 'collapsable',
        icon: 'heroicons_outline:globe-alt',
        children: [
            {
                id: 'website.azw-slider',
                title: 'Navigation.AZWSlider',
                type: 'basic',
                link: '/website/azw-slider',
            },
            {
                id: 'website.azw-slider-2',
                title: 'Navigation.AZWSlider2',
                type: 'basic',
                link: '/website/azw-slider-2',
            },
            {
                id: 'website.acs-slider',
                title: 'Navigation.ACSSlider',
                type: 'basic',
                link: '/website/acs-slider',
            },
            {
                id: 'website.acs-slider-2',
                title: 'Navigation.ACSSlider2',
                type: 'basic',
                link: '/website/acs-slider-2',
            },
        ],
    },
    {
        id: 'marketing',
        title: 'Navigation.Marketing',
        type: 'basic',
        icon: 'heroicons_outline:newspaper',
        children: [],
    },
    {
        id: 'templates',
        title: 'Navigation.Templates',
        type: 'collapsable',
        icon: 'heroicons_outline:document',
        children: [
            {
                id: 'templates.vehicle-contract',
                title: 'Navigation.VehicleContract',
                type: 'basic',
                link: '/templates/vehicle-contract',
            },
            {
                id: 'templates.vehicle-agb',
                title: 'Navigation.VehicleAGB',
                type: 'basic',
                link: '/templates/vehicle-agb',
            },
            {
                id: 'templates.vehicle-invoice',
                title: 'Navigation.VehicleInvoice',
                type: 'basic',
                link: '/templates/vehicle-invoice',
            },
            {
                id: 'templates.cash-receipt',
                title: 'Navigation.CashReceipt',
                type: 'basic',
                link: '/templates/cash-receipt',
            },
            {
                id: 'templates.bank-transfer-receipt',
                title: 'Navigation.BankTransferReceipt',
                type: 'basic',
                link: '/templates/bank-transfer-receipt',
            },
            {
                id: 'templates.test-drive',
                title: 'Navigation.TestDrive',
                type: 'basic',
                link: '/templates/test-drive',
            },
            {
                id: 'templates.purchase-contract',
                title: 'Navigation.PurchaseContract',
                type: 'basic',
                link: '/templates/purchase-contract',
            },
        ],
    },
    {
        id: 'email-templates',
        title: 'Navigation.EmailTemplates',
        type: 'collapsable',
        icon: 'heroicons_outline:document',
        children: [
            {
                id: 'email-templates.fixed',
                title: 'Navigation.Fixed',
                type: 'basic',
                link: '/email-templates/fixed',
            },
            {
                id: 'email-templates.dynamic',
                title: 'Navigation.Dynamic',
                type: 'basic',
                link: '/email-templates/dynamic',
            },
        ],
    },
    {
        id: 'support',
        title: 'Navigation.Support',
        type: 'collapsable',
        icon: 'heroicons_outline:question-mark-circle',
        children: [
            {
                id: 'support.tickets.my',
                title: 'Navigation.Tickets',
                type: 'basic',
                link: '/tickets/my',
            },
            {
                id: 'support.guidelines',
                title: 'Navigation.HelpCenter',
                type: 'basic',
                link: '/guidelines',
            },
        ],
    },
];
